import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/fda";
import { toast } from "sonner";

const CARDS = [
  ["today", "Today's Leads"], ["week", "This Week"], ["month", "This Month"],
  ["new", "New Leads"], ["uncontacted", "Uncontacted"], ["callbacks_due", "Callbacks Due"],
  ["contacted", "Contacted"], ["prospects", "Prospects"], ["referred", "Referred"],
  ["sales", "Sales"], ["unanswered", "Unanswered"], ["total", "Total Leads"],
];

export default function Dashboard() {
  const [d, setD] = useState(null);
  const lastTotal = useRef(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/dashboard");
        if (!alive) return;
        if (lastTotal.current !== null && data.total > lastTotal.current) {
          toast.success("New lead received", { description: `${data.total - lastTotal.current} new lead(s) in the CRM` });
        }
        lastTotal.current = data.total;
        setD(data);
      } catch { /* ignore */ }
    };
    load();
    const t = setInterval(load, 15000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!d) return <p className="text-sm text-forest-soft">Loading dashboard…</p>;

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl font-extrabold text-forest">Dashboard</h1>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map(([k, label]) => (
          <div key={k} data-testid={`stat-${k}`} className="rounded-2xl border border-border bg-white p-5">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-forest-soft">{label}</p>
            <p className="mt-2 font-display text-3xl font-extrabold text-forest">{d[k] ?? 0}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-12 font-display text-xl font-bold text-forest">Conversion</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[["lead_to_contact", "Lead → Contact"], ["lead_to_prospect", "Lead → Prospect"],
          ["prospect_to_sale", "Prospect → Sale"], ["lead_to_sale", "Lead → Sale"]].map(([k, label]) => (
          <div key={k} data-testid={`conv-${k}`} className="rounded-2xl bg-forest p-5 text-sand">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-sand/60">{label}</p>
            <p className="mt-2 font-display text-2xl font-extrabold">{d[k]}%</p>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-2xl border border-border bg-white p-5" data-testid="avg-first-contact">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-forest-soft">Average time to first contact <span className="normal-case tracking-normal text-[10px]">(last 1,000 leads)</span></p>
        <p className="mt-2 font-display text-2xl font-extrabold text-forest">
          {d.avg_hours_to_first_contact === null ? "No contacts yet" : `${d.avg_hours_to_first_contact} hours`}
        </p>
      </div>

      <Link to="/admin/leads" className="mt-10 inline-block rounded-full bg-terracotta px-6 py-3 text-xs font-extrabold uppercase tracking-wider text-white" data-testid="dashboard-view-leads">
        View all leads
      </Link>
    </div>
  );
}
